import { inject, Injectable } from '@angular/core';
import { JobStatus } from '../../../shared/models/generated/ziroModels';
import { PollingAbstractService } from '../../../shared/services/abstract/polling.abstract.service';
import { ActivatedRoute } from '@angular/router';

@Injectable()
export class MicrosoftDialPlanInventoriesPollingService extends PollingAbstractService<JobStatus> {
  private _route = inject(ActivatedRoute);
  tenantId = this._route.snapshot.paramMap.get('tenantId');
  baseUrl = `/services/microsoft/reporting/tenants/${this.tenantId}/dial-plan-inventory/status`;
}
